import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import * as FieldStyles from './TitleField.scss';
import { BaseText } from '../baseText/BaseTextField';

/**
 * @public
 */
export interface ITitleFieldProps {
  text: string;
  hasTitle: boolean;
  isLinkTitle: boolean;
  onClick: (evt: React.MouseEvent<HTMLElement>) => void;
  isDisabled?: boolean;
  ariaLabel?: string;
}

/**
 * @public
 */
export const TitleField: React.StatelessComponent<ITitleFieldProps> = (props: ITitleFieldProps) => {
  let { text, hasTitle, isLinkTitle, onClick, isDisabled, ariaLabel } = props;
  ariaLabel = ariaLabel || text;

  let renderLinkTitle = true;
  if (hasTitle && !isLinkTitle) {
    renderLinkTitle = false;
  }

  if (renderLinkTitle) {
    if (hasTitle) {
      return (
        <div
          data-automationid='FieldRenderer-title'
          className={ `${FieldStyles.titleField}` }
          data-is-focusable='true'
          role='button'
          aria-label={ ariaLabel }
          onClick={ onClick }
          title={ text }
          dangerouslySetInnerHTML={ { __html: text } }
        />
      );
    } else {
      return (
        <Link
          data-automationid='FieldRenderer-title'
          data-selection-invoke={ true }
          className={ `${FieldStyles.titleField}` }
          aria-label={ ariaLabel }
          onClick={ onClick }
          onDragStart={ preventDefault }
          title={ text }
        >
          { text }
        </Link>
      );
    }
  } else {
    // we're rendering title field here.
    return (
      <BaseText
        data-automationid='FieldRenderer-title'
        className={ `${FieldStyles.titleField}` }
        text={ text }
        isDisabled={ isDisabled }
        ariaLabel={ ariaLabel }
      />
    );
  }
};

function preventDefault(event: React.DragEvent<HTMLElement>): void {
  event.preventDefault();
}
